import { SHStack } from "@components/design-systems";
import {
  AnalysisSummaryDTO,
  RenderAnalysisSummaryItemProps,
} from "@models/platform-analysis/entities/steps/summary";
import { Collapse } from "@mui/material";
import { RootState } from "@redux/store";
import { memo } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";
import { AppendixBusinessMetricAnalysisTable } from "./analysis-table";
import { AppendixBusinessMetricAnalysisSectionTitle } from "./section-title";

export const SummaryAppendixBusinessMetricAnalysis = memo(
  ({ disabled: sectionDisabled }: RenderAnalysisSummaryItemProps) => {
    const { control } = useFormContext<AnalysisSummaryDTO>();
    const disqualifiedProductChunk = useSelector(
      (state: RootState) =>
        state.platformAnalysis.ui.summary.businessMetricAnalysis
          .disqualifiedProductChunk,
    );

    const totalProduct = disqualifiedProductChunk.reduce(
      (sum, arr) => sum + arr.length,
      0,
    );

    const watchedShowAppendixBusinessMetricAnalysis = useWatch({
      control,
      name: "showAppendixBusinessMetricAnalysis",
    });

    return (
      <>
        <Controller
          name="showAppendixBusinessMetricAnalysis"
          control={control}
          render={({ field: { value, onChange } }) => (
            <SHStack flexDirection={"row"} justifyContent={"space-between"}>
              <AppendixBusinessMetricAnalysisSectionTitle
                total={totalProduct}
                disabled={sectionDisabled}
                showAppendixBusinessMetricAnalysis={value ?? true}
                onChange={(value: boolean) => {
                  onChange(value);
                }}
              />
            </SHStack>
          )}
        />

        <Collapse
          unmountOnExit
          in={!!watchedShowAppendixBusinessMetricAnalysis}
        >
          <SHStack gap={2}>
            {disqualifiedProductChunk.map((item, index) => {
              return (
                <SHStack
                  flexDirection={"column"}
                  justifyContent={"space-between"}
                  gap={2}
                  key={index}
                >
                  {!!index && (
                    <AppendixBusinessMetricAnalysisSectionTitle
                      index={index}
                      total={totalProduct}
                      showAppendixBusinessMetricAnalysis={
                        !!watchedShowAppendixBusinessMetricAnalysis
                      }
                    />
                  )}

                  <AppendixBusinessMetricAnalysisTable
                    index={index}
                    selectedProducts={item}
                  />
                </SHStack>
              );
            })}
          </SHStack>
        </Collapse>
      </>
    );
  },
);
